import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Text, Tooltip, CloseButton } from 'pcln-design-system'
import styled from 'styled-components'

const StyledToolTip = styled(Tooltip)`
  white-space: nowrap;
`

const StyledMainContentFlex = styled(Flex)`
  width: ${(props) => props.containerWidth};
  height: auto;
  text-align: left;
  white-space: initial;
`

const LightboxToolTip = ({
  bgColor,
  color,
  handleLightboxClose,
  zIndex,
  orientation,
  children,
  containerWidth,
  containerMarginLeft,
  className,
}) => {
  if (!children) {
    return null
  }
  return (
    <StyledToolTip
      data-testid='LIGHTBOX_TOOLTIP'
      zIndex={zIndex}
      bg={bgColor}
      color={color}
      {...orientation}
      className={className}
      ml={containerMarginLeft}
    >
      <Flex flexDirection='row-reverse'>
        <Box>
          <CloseButton data-test='toolTip-close' onClick={handleLightboxClose} size={18} />
        </Box>
        <Box>
          <StyledMainContentFlex p={1} containerWidth={containerWidth} data-testid='TOOLTIP_CONTENT'>
            <Text fontSize={0}>{children}</Text>
          </StyledMainContentFlex>
        </Box>
      </Flex>
    </StyledToolTip>
  )
}

LightboxToolTip.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  handleLightboxClose: PropTypes.func,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  orientation: PropTypes.shape({
    bottom: PropTypes.bool,
    left: PropTypes.bool,
    top: PropTypes.bool,
    right: PropTypes.bool,
    center: PropTypes.bool,
  }),
  children: PropTypes.node,
  containerWidth: PropTypes.string,
  containerMarginLeft: PropTypes.string,
  className: PropTypes.string,
}

LightboxToolTip.defaultProps = {
  color: 'text',
  fontSize: 1,
  size: 16,
  bgColor: 'background.lightest',
  zIndex: 'auto',
  orientation: {
    bottom: true,
    left: true,
  },
  containerWidth: '225px',
  containerMarginLeft: '70px',
}

export default LightboxToolTip
